<div class="page-container reserve-result-content">
  <!--block:分析結果-->
  <div class="reserve-result-block">
    <!--標題title-->
    <h2 class="page-title">{{ 'reserve-result.title' | translate }}</h2>

    <!--風險因子區域 顯示前一階段健調表有勾選的疾病-->
    @if (allRiskItem.length === 0) {
      <p>{{ 'reserve-result.message' | translate }}</p>
    } @else {
      <p>{{ 'reserve-result.risk-message' | translate }}</p>
      <div class="reserve-result-tags-block">
        <div
          class="reserve-result-tags-scroll"
          (mousedown)="onMouseDown($event)"
          [class.active]="allRiskItem.length >= 5"
        >
          @for (riskItem of allRiskItem; track riskItem) {
            <span class="reserve-result-tags">{{ riskItem }}</span>
          }
        </div>
      </div>
    }

    <!--聚焦評估建議區域-->
    <div class="reserve-analysis-block">
      <div>
        <img
          width="56"
          height="56"
          ngSrc="assets/img/img-loadingAI-w.png"
          alt=""
        />
        <span
          [innerHTML]="
            'reserve-result.risk-hint'
              | translate: { riskItemsText: riskItemsText }
          "
        ></span>
      </div>
    </div>

    <!--動畫流程引導線-->
    <div class="reserve-analysis-line"></div>
  </div>

  <!--block:選擇方案-->
  <div class="reserve-plan-block">
    <!--三種方案卡片顯示的區塊-->
    <div class="reserve-card-block">
      <!--方案:全方位健檢-->
      <div class="reserve-plan-card">
        <h2 class="reserve-plan-title">
          {{ 'reserve-result.all-checkup' | translate }}
        </h2>
        <p
          class="reserve-plan-subtitle"
          [innerHTML]="'reserve-result.all-checkup-text' | translate"
        ></p>
        <div class="reserve-plan-checkup">
          @if (Number(allCheckup?.potentialCnt ?? 0) > 0) {
            <div class="reserve-plan-checkup-item">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <label>
                {{ allCheckup?.potentialCnt
                }}{{ 'reserve-result.item' | translate }}
                {{ 'reserve-result.potential' | translate }}
              </label>
            </div>
          }

          @if (Number(allCheckup?.abnormalCnt ?? 0) > 0) {
            <div class="reserve-plan-checkup-item">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <label>
                {{ allCheckup?.abnormalCnt
                }}{{ 'reserve-result.item' | translate }}
                {{ 'reserve-result.abnormal' | translate }}
              </label>
            </div>
          }
          <div class="reserve-plan-checkup-item">
            <img width="24" height="24" src="assets/img/i-check-green.svg" />
            <label>{{ 'reserve-result.standard' | translate }} </label>
          </div>
        </div>
        <div class="reserve-price-block first-price-block">
          <span class="reserve-plan-price">
            <label>$</label>
            {{ calculatedAllCheckupPrice | numberComma }}
          </span>
          <button
            mat-button
            (click)="choosePackage(0)"
            class="btn-fill-primary btn-size-l"
          >
            {{ 'reserve-result.choose-this-package' | translate }}
          </button>
        </div>
      </div>
      <!--方案:智能專屬-->
      <div class="reserve-plan-card">
        <h2 class="reserve-plan-title">
          {{ 'reserve-result.ai-exclusive' | translate }}
        </h2>
        <p
          class="reserve-plan-subtitle"
          [innerHTML]="'reserve-result.ai-exclusive-text' | translate"
        ></p>
        <div class="reserve-plan-checkup">
          @if (Number(aiExclusive?.potentialCnt ?? 0) > 0) {
            <div class="reserve-plan-checkup-item">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <label>
                {{ aiExclusive?.potentialCnt
                }}{{ 'reserve-result.item' | translate }}
                {{ 'reserve-result.potential' | translate }}
              </label>
            </div>
          }
          @if (Number(aiExclusive?.abnormalCnt ?? 0) > 0) {
            <div class="reserve-plan-checkup-item">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <label>
                {{ aiExclusive?.abnormalCnt
                }}{{ 'reserve-result.item' | translate }}
                {{ 'reserve-result.abnormal' | translate }}
              </label>
            </div>
          }
          <div class="reserve-plan-checkup-item">
            <img width="24" height="24" src="assets/img/i-check-green.svg" />
            <label>{{ 'reserve-result.standard' | translate }} </label>
          </div>
        </div>
        <div class="reserve-price-block">
          <span class="reserve-plan-price">
            <label>$</label>
            {{ calculatedAiExclusivePrice | numberComma }}
          </span>
          <button
            mat-button
            (click)="choosePackage(1)"
            class="btn-fill-primary btn-size-l"
          >
            {{ 'reserve-result.choose-this-package' | translate }}
          </button>
        </div>
      </div>
      <!--方案:基礎健檢-->
      <div class="reserve-plan-card">
        <h2 class="reserve-plan-title">
          {{ 'reserve-result.basic-checkup' | translate }}
        </h2>
        <p
          class="reserve-plan-subtitle"
          [innerHTML]="'reserve-result.basic-checkup-text' | translate"
        ></p>
        <div class="reserve-plan-checkup">
          @if (Number(basicCheckup?.potentialCnt ?? 0) > 0) {
            <div class="reserve-plan-checkup-item">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <label>
                {{ basicCheckup?.potentialCnt
                }}{{ 'reserve-result.item' | translate }}
                {{ 'reserve-result.potential' | translate }}
              </label>
            </div>
          }
          @if (Number(basicCheckup?.abnormalCnt ?? 0) > 0) {
            <div class="reserve-plan-checkup-item">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <label>
                {{ basicCheckup?.abnormalCnt
                }}{{ 'reserve-result.item' | translate }}
                {{ 'reserve-result.abnormal' | translate }}
              </label>
            </div>
          }
          <div class="reserve-plan-checkup-item">
            <img width="24" height="24" src="assets/img/i-check-green.svg" />
            <label>{{ 'reserve-result.standard' | translate }} </label>
          </div>
        </div>
        <div class="reserve-price-block">
          <span class="reserve-plan-price">
            <label>$</label>
            {{ calculatedBasicCheckupPrice | numberComma }}
          </span>
          <button
            mat-button
            (click)="choosePackage(2)"
            class="btn-outline-primary btn-size-l"
          >
            {{ 'reserve-result.choose-this-package' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!--方案差異區域-->
    <div class="reserve-table-block">
      <!--title 標題-->
      <div class="page-title-block">
        <div class="page-subtitle-block">
          <img
            width="32"
            height="32"
            ngSrc="assets/img/i-light.svg"
            alt="light"
          />
          <p>{{ 'reserve-result.package-hint' | translate }}</p>
        </div>
        <h2 class="page-title">
          {{ 'reserve-result.package-difference' | translate }}
        </h2>
      </div>

      <!--table 表格-->
      <div class="plan-table-block">
        @for (item of allExamInfoGroupByType; track item[0]; let i = $index) {
          <div class="plan-table">
            <!-- table-header 表頭-->
            <div class="plan-table-header">
              <div class="plan-table-header-title">{{ item[0] }}</div>
              <div class="plan-table-header-items">
                <span></span>
                <span></span>
                <span>
                  {{ 'reserve-result.all-checkup' | translate }}
                  @if (getAllCheckupCountByExamTypeIndex(i) > 0) {
                    <div class="plan-count">
                      <p>{{ getAllCheckupCountByExamTypeIndex(i) }}</p>
                    </div>
                  }
                </span>
                <span>
                  {{ 'reserve-result.ai-exclusive' | translate }}
                  @if (getAiExclusiveCountByExamTypeIndex(i) > 0) {
                    <div class="plan-count">
                      <p>{{ getAiExclusiveCountByExamTypeIndex(i) }}</p>
                    </div>
                  }
                </span>
                <span>
                  {{ 'reserve-result.basic-checkup' | translate }}
                  @if (getBasicCheckupCountByExamTypeIndex(i) > 0) {
                    <div class="plan-count">
                      <p>{{ getBasicCheckupCountByExamTypeIndex(i) }}</p>
                    </div>
                  }
                </span>
              </div>
            </div>

            <!-- table-body 內文-->
            <div class="plan-table-body">
              @for (
                examInfo of item[1];
                track examInfo.examItem;
                let j = $index
              ) {
                @if (j < 3 || isExamInfoGroupByTypeShowAll[i]) {
                  <div class="plan-table-list">
                    <div class="plan-table-list-category">
                      {{ examInfo.deptName }}
                    </div>
                    <div class="plan-table-list-item">
                      <div class="plan-table-list-name">
                        <span>{{ examInfo.examName }}</span>

                        <!--mobile:顯示info按鈕-->
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(examInfo)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                      </div>

                      <span class="plan-table-list-memo">{{
                        examInfo.examMemo
                      }}</span>
                      <div class="plan-check">
                        <span></span>
                        <span></span>
                        <span>
                          @if (isAllCheckupChecked(examInfo)) {
                            <img
                              width="20"
                              height="20"
                              ngSrc="assets/img/i-check-green.svg"
                              alt=""
                            />
                          }
                        </span>
                        <span>
                          @if (isAiExclusiveChecked(examInfo)) {
                            <img
                              width="20"
                              height="20"
                              ngSrc="assets/img/i-check-green.svg"
                              alt=""
                            />
                          }
                        </span>
                        <span>
                          @if (isBasicCheckupChecked(examInfo)) {
                            <img
                              width="20"
                              height="20"
                              ngSrc="assets/img/i-check-green.svg"
                              alt=""
                            />
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>

            @if (item[1].length > 3) {
              <!-- table-footer 展開-->
              <div class="plan-table-footer">
                <button
                  type="button"
                  mat-button
                  class="btn-text-primary btn-size-m"
                  (click)="toggleExamInfoGroupByTypeShowAll(i)"
                >
                  {{
                    isExamInfoGroupByTypeShowAll[i]
                      ? ('reserve-result.less' | translate)
                      : ('reserve-result.more' | translate)
                  }}
                  <img
                    [ngSrc]="
                      isExamInfoGroupByTypeShowAll[i]
                        ? 'assets/img/i-minus.svg'
                        : 'assets/img/i-add.svg'
                    "
                    width="12"
                    height="12"
                    alt="toggle icon"
                  />
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!--block：固定方案區域 當頁面持續下拉至三個卡片消失時 此固定區塊將顯示方便讓使用者點選方案 -->
  <div class="table-fixed-plan-block" [class.active]="isTableFixedActive">
    <div class="table-fixed-content">
      <!--標題區塊-->
      <span class="table-fixed-title" [@fadeInOut]="animationKey">{{
        currentTableHeaderTitle
      }}</span>

      <!--固定方案區塊-->
      <div class="fixed-plan-block">
        <div class="fixed-plan">
          <h3 class="reserve-plan-title">
            {{ 'reserve-result.all-checkup' | translate }}
          </h3>
          <span class="reserve-plan-price">
            <label>$</label>
            {{ calculatedAllCheckupPrice | numberComma }}
          </span>
          <button
            mat-button
            (click)="choosePackage(0)"
            class="btn-fill-primary btn-size-l"
          >
            {{ 'reserve-result.choose-this-package' | translate }}
          </button>
        </div>
        <div class="fixed-plan">
          <h3 class="reserve-plan-title">
            {{ 'reserve-result.ai-exclusive' | translate }}
          </h3>
          <span class="reserve-plan-price">
            <label>$</label>
            {{ calculatedAiExclusivePrice | numberComma }}
          </span>
          <button
            mat-button
            (click)="choosePackage(1)"
            class="btn-fill-primary btn-size-l"
          >
            {{ 'reserve-result.choose-this-package' | translate }}
          </button>
        </div>
        <div class="fixed-plan">
          <h3 class="reserve-plan-title">
            {{ 'reserve-result.basic-checkup' | translate }}
          </h3>
          <span class="reserve-plan-price">
            <label>$</label>
            {{ calculatedBasicCheckupPrice | numberComma }}
          </span>
          <button
            mat-button
            (click)="choosePackage(2)"
            class="btn-outline-primary btn-size-l"
          >
            {{ 'reserve-result.choose-this-package' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
